"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _propTypes = require("prop-types");

var _system = _interopRequireDefault(require("../../../utils/system"));

var _TableContext = _interopRequireDefault(require("../TableContext/TableContext"));

var _TableHead = _interopRequireDefault(require("../TableHead/TableHead"));

var _TableBody = _interopRequireDefault(require("../TableBody/TableBody"));

var _TableFooter = _interopRequireDefault(require("../TableFooter/TableFooter"));

var _TableRow = _interopRequireDefault(require("../TableRow/TableRow"));

var _TableCell = _interopRequireDefault(require("../TableCell/TableCell"));

var _TablePagination = _interopRequireDefault(require("../TablePagination/TablePagination"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var propTypes = {
  /**
   * Allows TableCells to inherit the prop dense of the Table.
   */
  dense: _propTypes.bool,

  /**
   * Apply border to table cells
   */
  bordered: _propTypes.bool,

  /**
   * Stripped background
   */
  striped: _propTypes.bool,

  /**
   * Use hover effect in rows
   */
  hovered: _propTypes.bool
};
var defaultProps = {
  dense: false,
  bordered: false,
  striped: false,
  hovered: false
};
var Table = (0, _system["default"])('table')({
  label: 'Table'
}, (0, _css["default"])({
  border: 0,
  borderCollapse: 'collapse',
  borderSpacing: 0,
  boxSizing: 'border-box',
  display: 'table',
  whiteSpace: 'nowrap',
  width: '100%'
}), function (props) {
  return props.bordered && (0, _css["default"])({
    border: '1px',
    borderColor: 'gray.200'
  });
});
var TableContainer = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "etfjuvk0"
} : {
  target: "etfjuvk0",
  label: "TableContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1joa0ik",
  styles: "overflow-x:auto;width:100%"
} : {
  name: "1joa0ik",
  styles: "overflow-x:auto;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var bordered = props.bordered,
      dense = props.dense,
      striped = props.striped,
      hovered = props.hovered;
  var value = (0, _react.useMemo)(function () {
    return {
      bordered: bordered,
      dense: dense,
      striped: striped,
      hovered: hovered
    };
  }, [bordered, dense, striped, hovered]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContext["default"].Provider, {
    value: value,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TableContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Table, _objectSpread({
        ref: ref
      }, props))
    })
  });
});
Component.displayName = 'Table';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
Component.Head = _TableHead["default"];
Component.Body = _TableBody["default"];
Component.Footer = _TableFooter["default"];
Component.Row = _TableRow["default"];
Component.Cell = _TableCell["default"];
Component.Pagination = _TablePagination["default"];
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Table.js.map